var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCanBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83838 1.50049V0.500488C6.83838 0.22435 7.06226 0.000488281 7.33838 0.000488281H12.3374C12.6135 0.000488281 12.8374 0.22435 12.8374 0.500488V1.50049C12.8374 1.77663 12.6135 2.00049 12.3374 2.00049H7.33838C7.06226 2.00049 6.83838 1.77663 6.83838 1.50049Z",
    fill: "#567AE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33813 7.00018H8.33813C8.61426 7.00018 8.83813 7.22403 8.83813 7.50018V15.5002C8.83813 15.7763 8.61426 16.0002 8.33813 16.0002H7.33813C7.06201 16.0002 6.83813 15.7763 6.83813 15.5002V7.50018C6.83813 7.22403 7.06201 7.00018 7.33813 7.00018Z",
    fill: "#567AE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3381 7.00018H11.3381C11.062 7.00018 10.8381 7.22403 10.8381 7.50018V15.5002C10.8381 15.7763 11.062 16.0002 11.3381 16.0002H12.3381C12.6143 16.0002 12.8381 15.7763 12.8381 15.5002V7.50018C12.8381 7.22403 12.6143 7.00018 12.3381 7.00018Z",
    fill: "#567AE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3381 5.00018H16.8381L16.3704 19.0335C16.3524 19.5725 15.9103 20.0002 15.371 20.0002H4.3053C3.76599 20.0002 3.32385 19.5725 3.30591 19.0335L2.83813 5.00018H1.33813C1.06201 5.00018 0.838135 4.77632 0.838135 4.50018V3.50018C0.838135 3.22404 1.06201 3.00018 1.33813 3.00018H18.3381C18.6143 3.00018 18.8381 3.22404 18.8381 3.50018V4.50018C18.8381 4.77632 18.6143 5.00018 18.3381 5.00018ZM14.8381 5.00018H4.83813L5.33813 18.0002H14.3381L14.8381 5.00018Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanBlue);
export default __webpack_public_path__ + "static/media/trashCanBlue.82b91b32.svg";
export { ForwardRef as ReactComponent };